import { RichText } from '@seek/cmsu-rich-text';
import { Heading, Stack } from 'braid-design-system';
import React from 'react';
import type { AuthorLocalization } from '../../../helpers/loadersHelper';
import { richTextRenderers } from '../modules';

import AuthorProfileImage from './images/author-profile-image.png';

type Props = {
  author: AuthorLocalization;
};

export const AuthorProfile = ({
  author: { name, description, image },
}: Props) => (
  <Stack space="gutter">
    <img
      src={image?.url || AuthorProfileImage}
      alt={image?.alt || ''}
      style={{
        height: '96px',
        width: '96px',
        borderRadius: '50%',
      }}
    />
    <Heading level="2">
      <span data-testid="Author_Name_TestId">{name}</span>
    </Heading>
    <RichText content={description?.raw} renderers={richTextRenderers} />
  </Stack>
);
